import { createRouter, createWebHashHistory } from 'vue-router'

import NProgress from 'nprogress'
import Layout from '../views/layout'


// const children=[...test]

// 导出路由配置供其他模块使用（如侧边栏组件）
export const routes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/news/type',
    hidden: true,
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '首页', icon: 'el-icon-s-home' }
    }]
  },



  {
    path: '/linkURl',
    component: Layout,
    hidden: true,
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/friendLink/list'),
      meta: { title: '友情链接', icon: 'el-icon-s-home' }
    }]
  },





  {
    path: '/news/detail',
    component: () => import('@/views/news/list/detail'),
    hidden: true
  },

  {
    path: '/news',
    component: Layout,
    redirect: '/news',
    name: 'news',
    redirect: '/news/list',
    meta: { title: '新闻管理', icon: 'el-icon-news' },
    children: [
      {
        path: 'type',
        name: 'newsType',
        keepAlive: true,
        component: () => import('../views/news/type/index'),
        meta: { title: '新闻分类' }
      },
      {
        path: 'list',
        name: 'newsList',
        keepAlive: true,
        component: () => import('../views/news/list/index'),
        meta: { title: '新闻文章' }
      },
      {
        path: 'create',
        hidden: true,
        name: 'createNews',
        component: () => import('../views/news/list/createNews'),
        meta: { title: '发布新闻' }
      }

    ]
  },

  {
    path: '/case',
    component: Layout,
    redirect: '/case',
    name: 'case',
    redirect: '/case/list',
    meta: { title: '案例管理', icon: 'el-icon-news' },
    children: [
      {
        path: 'type',
        name: 'caseType',
        keepAlive: true,
        component: () => import('../views/case/type/index'),
        meta: { title: '案例分类' }
      },
      {
        path: 'list',
        name: 'caseList',
        keepAlive: true,
        component: () => import('../views/case/list/index'),
        meta: { title: '案例列表' }
      },
      {
        path: 'create',
        hidden: true,
        name: 'createcase',
        component: () => import('../views/case/list/createcase'),
        meta: { title: '创建案例' }
      }

    ]
  },
  {
    path: '/case/detail',
    component: () => import('@/views/case/list/detail'),
    hidden: true
  },

  {
    path: '/Advertising',
    component: Layout,
    redirect: '/Advertising/firstPage_banner',
    name: 'Advertising',
    meta: { title: '广告管理', icon: 'el-icon-postcard' },
    children: [
      {
        path: 'firstPage_banner',
        name: 'firstPage_banner',
        component: () => import('@/views/Advertising/firstPage_banner/index'),
        meta: { title: '首页轮播图' }
      },
      {
        path: 'createAdBanner',
        name: 'createAdBanner',
        hidden: true,
        component: () => import('@/views/Advertising/firstPage_banner/createAdBanner'),
        meta: { title: '新增轮播图' }
      },
      {
        path: 'editAdBanner',
        name: 'editAdBanner',
        hidden: true,
        component: () => import('@/views/Advertising/firstPage_banner/createAdBanner'),
        meta: { title: '修改轮播图' }
      },
      {
        path: 'routeList',
        name: 'routeList',
        hidden: true,
        component: () => import('@/views/Advertising/routeList/index'),
        meta: { title: '推荐路线' }
      }
    ]
  },


  {
    path: '/company',
    component: Layout,
    redirect: '/company/contactUs',
    name: 'company',
    meta: { title: '联系我们', icon: 'el-icon-s-help' },
    children: [
      {
        path: 'contactUs',
        name: 'contactUs',
        component: () => import('@/views/aboutUs/contactUs/index'),
        meta: { title: '联系我们', icon: 'el-icon-phone' }
      },
      {
        path: 'createCompany',
        hidden: true,
        name: 'createCompany',
        component: () => import('../views/aboutUs/contactUs/create'),
        meta: { title: '新增分公司' }
      }
    ]
  },
  {
    path: '/product',
    component: Layout,
    hidden: true,
    redirect: '/product/productCase',
    name: 'product',
    meta: { title: '客户案例', icon: 'el-icon-warning' },
    children: [
      {
        path: 'productCase',
        name: 'productCase',
        component: () => import('@/views/aboutUs/productCase/index'),
        meta: { title: '客户案例', icon: 'el-icon-warning' }
      },

      {
        path: 'create',
        hidden: true,
        name: 'createproduct',
        component: () => import('../views/aboutUs/productCase/create'),
        meta: { title: '新建客户案例' }
      }
    ]
  },

  // 友情链接先不上   等后台接口 
  // {
  //   path: '/linkURl',
  //   component: Layout,
  //   redirect: '/linkURl/list',
  //   name: 'linkURl',
  //   meta: { title: '友情链接', icon: 'el-icon-s-help' },
  //   children: [
  //     {
  //       path: 'list',
  //       name: 'list',
  //       component: () => import('@/views/friendLink/index'),
  //       meta: { title: '友情链接', icon: 'el-icon-phone' }
  //     }
  //   ]
  // },

  {
    path: '/recruitment',
    component: Layout,
    redirect: '/recruitment/list',
    name: 'recruitment',
    meta: { title: '招聘管理', icon: 'el-icon-user' },
    children: [
      {
        path: 'list',
        name: 'recruitmentList',
        keepAlive: true,
        component: () => import('../views/recruitment/index'),
        meta: { title: '招聘管理' }
      }
    ]
  },

  {
    path: '/system',
    component: Layout,
    redirect: '/system/config',
    name: 'system',
    hidden: true,
    meta: { title: '系统功能', icon: 'el-icon-s-help' },
    children: [
      {
        path: 'config',
        name: 'config',
        component: () => import('@/views/system/config/index'),
        meta: { title: '系统设置', icon: 'el-icon-setting' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})
// 路由守卫  判断是否登录  没有登录跳回登录页
// 添加权限验证
import { hasPermission, getDefaultRoute } from '@/config/permission'
import { ElMessage } from 'element-plus'

router.beforeEach((to, from) => {
  NProgress.start()

  // 登录页直接放行
  if (to.path === "/login") {
    return true
  }

  // 检查是否已登录
  const token = sessionStorage.getItem('TOKEN')
  const username = sessionStorage.getItem('USERNAME')

  if (!token || !username) {
    // 未登录，跳转到登录页
    ElMessage.warning('请先登录')
    return `/login?redirect=${to.fullPath}`
  }

  // 特殊处理：如果访问根路径，重定向到用户的默认首页
  if (to.path === '/') {
    const defaultRoute = getDefaultRoute(username)
    console.log('访问根路径，重定向到:', defaultRoute)
    return defaultRoute
  }

  // 已登录，检查路由权限
  // 对于 hidden 的路由（如详情页、编辑页），通常不需要单独配置权限
  // 如果路由没有 name，直接放行（通常是一些特殊路由）
  if (!to.name) {
    return true
  }

  // 检查用户是否有权限访问该路由
  if (!hasPermission(username, to.name)) {
    // 只在不是从登录页跳转过来时才显示错误提示
    // 避免登录后立即显示"没有权限"的错误
    if (from.path !== '/login') {
      ElMessage.error('您没有权限访问该页面')
    }

    // 跳转到用户的默认首页
    const defaultRoute = getDefaultRoute(username)
    console.log('无权限访问', to.path, '，重定向到:', defaultRoute)
    return defaultRoute
  }

  return true
})


export default router